<template>
  <div class="box box--mapBlock">
    <div class="box__inner">
      <div class="mapBlock js-tabBox mapBlock--detail">
        <div class="mapBlock__header">
          <div class="mapBlock__header-top">
            <div class="mapBlock__header-inner">
              <div class="mapBlock__breadcrumbs">
                <Breadcrumbs/>
              </div>
              <div class="mapBlock__info">
                <div class="mapBlock__info-left">
                  <div class="mapBlock__info-title">Search:</div>
                  <router-link class="mapBlock__info-link" to="map-search">edit search</router-link>
                </div>
                <div class="mapBlock__info-right">
                  <div class="mapBlock__info-list">
                    <div class="mapBlock__info-list-item mapBlock__info-list-item--route">
                      <div class="mapBlock__info-list-icon">
                        <SvgIcon name="placeholder"/>
                      </div>
                      <div class="mapBlock__info-list-text">
                        <span class="text text--departure">New York-area</span>
                        <span class="arrow">
                          <SvgIcon name="long-left-arrow"/>
                        </span>
                        <span class="text text--arrival">Orlando International Airport (MCO)</span>
                      </div>
                    </div>
                    <div class="mapBlock__info-list-item mapBlock__info-list-item--way">
                      <div class="mapBlock__info-list-icon">
                        <SvgIcon name="airplane"/>
                      </div>
                      <div class="mapBlock__info-list-text">One way</div>
                    </div>
                    <div class="mapBlock__info-list-item mapBlock__info-list-item--date">
                      <div class="mapBlock__info-list-icon">
                        <SvgIcon name="calendar"/>
                      </div>
                      <div class="mapBlock__info-list-text">
                        <span class="text text--desktop">July 25, 2018</span>
                        <span class="text text--mobile">07/25/18</span>
                      </div>
                    </div>
                    <div class="mapBlock__info-list-item mapBlock__info-list-item--count">
                      <div class="mapBlock__info-list-icon">
                        <SvgIcon name="user"/>
                      </div>
                      <div class="mapBlock__info-list-text">
                        <span>3</span>
                        <span class="text text--desktop">&ensp;Passengers</span>
                      </div>
                    </div>
                    <div class="mapBlock__info-list-item mapBlock__info-list-item--type">
                      <div class="mapBlock__info-list-icon">
                        <SvgIcon name="charter-flight"/>
                      </div>
                      <div class="mapBlock__info-list-text">Charter Seats, Commercial Seats</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mapBlock__header-bottom js-tabNav-wrap">
            <div class="mapBlock__tab-nav">
              <div class="mapBlock__tab-nav-item js-tabNavItem" data-id="aircraft" @click="tabActivate">
                <span class="text">Aircraft</span>
              </div>
              <div class="mapBlock__tab-nav-item js-tabNavItem" data-id="aircraftProvider" @click="tabActivate">
                <span class="text">Aircraft provider</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mapBlock__content">
          <router-link class="mapBlock__sidebar-title mapBlock__sidebar-title--aircraft" to="map-search">
            <div class="mapBlock__sidebar-title-inner">
              <span class="text">Map</span>
              <span class="icon">
                  <SvgIcon name="down-arrow"/>
                </span>
            </div>
          </router-link>
          <router-link class="mapBlock__sidebar-title mapBlock__sidebar-title--aircraft" to="search-results">
            <div class="mapBlock__sidebar-title-inner">
              <span class="text">Search results</span>
              <span class="icon">
                  <SvgIcon name="down-arrow"/>
                </span>
            </div>
          </router-link>
          <div class="mapBlock__sidebar-content mapBlock__sidebar-content--aircraft">
            <div class="mapBlock__tab-content">
              <div class="mapBlock__tab-content-item js-tabContentItem">
                <div class="mapBlock__tab-content-inner">
                  <vue-scroll :ops="ops">
                    <div class="mapBlock__detail js-customScroll">
                      <div class="mapBlock__bidding mapBlock__bidding--buy-it-now">
                        <div class="mapBlock__bidding-column">
                          <div class="mapBlock__bidding-title">Time left</div>
                          <div class="mapBlock__bidding-text">8h:30min</div>
                        </div>
                        <div class="mapBlock__bidding-column">
                          <div class="mapBlock__bidding-title">Type:</div>
                          <div class="mapBlock__bidding-list js-bidding-list">
                            <div class="mapBlock__bidding-list-item js-bidding-list-item active"
                                 data-current-bid-price="$1,000.00" data-buy-it-now-price="$11,000.00">Plane
                            </div>
                            <div class="mapBlock__bidding-list-item js-bidding-list-item"
                                 data-current-bid-price="$2,000.00" data-buy-it-now-price="$22,000.00">Spaces
                            </div>
                            <div class="mapBlock__bidding-list-item js-bidding-list-item"
                                 data-current-bid-price="$3,000.00" data-buy-it-now-price="$33,000.00">Seats
                            </div>
                          </div>
                          <div class="mapBlock__bidding-list mapBlock__bidding-list--small js-bidding-list">
                            <div class="mapBlock__bidding-list-item js-bidding-list-item active"
                                 data-current-bid-price="$25,000.00" data-buy-it-now-price="$35,000.00">Aircraft
                              provider
                              upload
                            </div>
                            <div class="mapBlock__bidding-list-item js-bidding-list-item"
                                 data-current-bid-price="$45,000.00" data-buy-it-now-price="$55,000.00">Flyer re-sale
                            </div>
                          </div>
                        </div>
                        <div class="mapBlock__bidding-column">
                          <div class="mapBlock__bidding-title">Current bid price</div>
                          <div class="mapBlock__bidding-price js-current-bid-price">$10,500.00</div>
                          <div class="mapBlock__bidding-caption">12 BIDS</div>
                        </div>
                        <div class="mapBlock__bidding-column">
                          <form
                            class="form form--bidding js-ajaxForm"
                            data-href="/"
                            data-action="bidding"
                            id="biddingForm"
                            @submit.prevent="submitHandler"
                            :class="{'loading' : loading}"
                          >
                            <label class="form__label form__label--text price">
                              <div class="form__field-wrapper">
                                <input
                                  class="form__field"
                                  type="text"
                                  placeholder="Enter bid"
                                  autocomplete="off"
                                  v-model.lazy="bid"
                                  v-money="money"
                                  :disabled="loading"
                                />
                                <div class="form__caption">Increments of $1,000.00 min</div>
                              </div>
                            </label>
                            <div class="form__label form__label--button">
                              <button class="form__button" :disabled="loading"><span class="text">BID</span></button>
                            </div>
                          </form>
                        </div>
                        <div class="mapBlock__bidding-column">
                          <div class="mapBlock__bidding-title">Buy-it-now price</div>
                          <div class="mapBlock__bidding-price js-buy-it-now-price">$30,000.00</div>
                        </div>
                        <div class="mapBlock__bidding-column">
                          <button class="mapBlock__bidding-button" type="button">
                            <span class="text">Buy-it-now</span>
                          </button>
                        </div>
                      </div>
                      <AircraftDetail v-if="sliderOne" :category="'Aircraft'" :title="'Gulfstream 500 (G500)'"/>
                    </div>
                  </vue-scroll>
                </div>
              </div>
              <div class="mapBlock__tab-content-item js-tabContentItem">
                <div class="mapBlock__tab-content-inner">
                  <vue-scroll :ops="ops">
                    <div class="mapBlock__detail js-customScroll">
                      <AircraftDetail v-if="sliderTwo" :category="'Aircraft provider'" :title="'Fly corporation'"/>
                    </div>
                  </vue-scroll>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/common/Breadcrumbs/Breadcrumbs'
  import SvgIcon from '@/components/common/SvgIcon/SvgIcon'
  import { Tabs } from '@/js/plugins/tabs'
  import AircraftDetail from '@/components/AircraftDetail/AircraftDetail'
  import { VMoney } from 'v-money'

  export default {
    name: 'AircraftDetailBid',
    data: () => ({
      tabs: new Tabs('.js-tabNavItem', '.js-tabContentItem'),
      sliderOne: true,
      sliderTwo: false,
      bid: '',
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
      },
      ops: {
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
      loading: false,
    }),
    directives: { money: VMoney },
    mounted () {
      this.tabs.addActiveForMouted()

      const currentBidPriceBox = document.querySelector('.js-current-bid-price')
      const buyItNowPriceBox = document.querySelector('.js-buy-it-now-price')

      document.querySelectorAll('.js-bidding-list-item').forEach((item) => {
        item.addEventListener('click', (event) => {
          item.classList.remove('active')
          const elem = event.currentTarget
          const currentBidPrice = elem.getAttribute('data-current-bid-price') || 'data-price not found'
          const buyItNowPrice = elem.getAttribute('data-buy-it-now-price') || 'data-price not found'

          const list = elem.closest('.js-bidding-list')
          list.querySelectorAll('.js-bidding-list-item').forEach(list => list.classList.remove('active'))
          elem.classList.add('active')

          if (currentBidPriceBox.length !== 0) currentBidPriceBox.innerHTML = currentBidPrice
          if (buyItNowPriceBox.length !== 0) buyItNowPriceBox.innerHTML = buyItNowPrice
        })
      })
    },
    methods: {
      tabActivate (event) {
        const type = event.currentTarget.getAttribute('data-id')
        this.tabs.addActiveForClick(event.currentTarget)
        if (type === 'aircraftProvider') {
          this.sliderOne = false
          this.sliderTwo = true
        } else {
          this.sliderOne = true
          this.sliderTwo = false
        }
      },
      submitHandler () {
        if (this.bid === '$ 0.00') {
          return false
        }

        this.loading = true

        const data = {
          bid: this.bid,
        }
        console.log(data)
      },
    },
    components: {
      Breadcrumbs,
      SvgIcon,
      AircraftDetail,
    },
    metaInfo: {
      meta: [{
        name: 'robots', content: 'noindex',
      }],
    },
  }
</script>
